module.exports = __webpack_public_path__ + "static/media/interest_list_white.1c5beac8.svg";